import styled, { css } from 'styled-components';
import { flexColumn } from '@stylesheets/helpers';
import { CODE_FONT_FAMILY } from '@stylesheets/font';

export const Wrapper = styled.div`
  ${flexColumn};

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level6} 0;
    gap: ${spacing.level2};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4} 0;
    `}
  }
`;

export const SetupSection = styled.div`
  ${flexColumn};

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level6};
    padding-top: ${spacing.level5};
  `}
`;

export const StepCard = styled.div`
  ${flexColumn};

  ${({ theme: { spacing, colors, borderRadius } }) => css`
    gap: ${spacing.level4};
    padding: ${spacing.level5};
    background: ${colors.surfaceContainerLow};
    border-radius: ${borderRadius.large};
  `}
`;

export const StepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;

  ${({ theme: { colors, font, borderRadius } }) => css`
    background: ${colors.primary};
    color: ${colors.onPrimary};
    border-radius: ${borderRadius.full};
    font-size: ${font.labelMedium.fontSize};
    font-weight: ${font.labelMedium.fontWeight};
  `}
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;

export const StepTitle = styled.h3`
  margin: 0;

  ${({ theme: { font, colors } }) => css`
    font-size: ${font.titleSmall.fontSize};
    font-weight: ${font.titleSmall.fontWeight};
    line-height: ${font.titleSmall.lineHeight};
    color: ${colors.onSurface};
  `}
`;

export const StepDescription = styled.p`
  margin: 0;

  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    line-height: ${font.bodyMedium.lineHeight};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const QrContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;

  ${({ theme: { spacing, borderRadius } }) => css`
    padding: ${spacing.level6};
    background: #ffffff;
    border-radius: ${borderRadius.large};
  `}
`;

export const SecretCode = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme: { spacing, colors, borderRadius } }) => css`
    gap: ${spacing.level3};
    padding: ${spacing.level3} ${spacing.level4};
    background: ${colors.surfaceContainerHigh};
    border-radius: ${borderRadius.small};
    border: 1px solid ${colors.outlineVariant};
  `}
`;

export const SecretText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme: { font, colors } }) => css`
    font-family: ${CODE_FONT_FAMILY};
    font-size: ${font.bodySmall.fontSize};
    line-height: ${font.bodySmall.lineHeight};
    color: ${colors.onSurface};
    word-break: break-all;
  `}
`;

export const VerifyForm = styled.div`
  display: flex;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level4};
  `}

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CodeInput = styled.input`
  text-align: center;
  width: 180px;

  ${({ theme: { colors, font, spacing, borderRadius } }) => css`
    padding: ${spacing.level3} ${spacing.level5};
    border-radius: ${borderRadius.small};
    border: 1px solid ${colors.outline};
    background: transparent;
    color: ${colors.onSurface};
    font-family: ${CODE_FONT_FAMILY};
    font-size: ${font.titleMedium.fontSize};
    letter-spacing: 0.35em;

    &:focus {
      outline: none;
      border-color: ${colors.primary};
      box-shadow: 0 0 0 1px ${colors.primary};
    }

    &:disabled {
      opacity: 0.5;
    }

    &::placeholder {
      color: ${colors.outlineVariant};
      letter-spacing: 0.35em;
    }

    @media (max-width: 480px) {
      width: 100%;
    }
  `}
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
    padding-top: ${spacing.level2};
  `}
`;

export const EnforcementNote = styled.p`
  margin: 0;

  ${({ theme: { font, colors, spacing } }) => css`
    font-size: ${font.bodySmall.fontSize};
    line-height: ${font.bodySmall.lineHeight};
    color: ${colors.onSurfaceVariant};
    font-style: italic;
    padding-top: ${spacing.level2};
  `}
`;
